import React from 'react';
import {TertiaryLink} from "@sfly/uig-button";
import {redirectToSignIn, redirectToSignUp} from './../../../../redux/actions';

class NotSignedInDialog extends React.Component {
    signIn = () => {
        console.log('sognin');
        redirectToSignIn();
    }

    signUp = () => {
        console.log('signup')
        redirectToSignUp();
    }

    render() {
        return (<div className="not-signedin-container">
            <TertiaryLink onClick={this.signIn}>Sign in to leave a message</TertiaryLink>
        </div>)
    }
}

export default NotSignedInDialog;